import React from 'react';
import { fill, percentage } from './labels';

// Four instances of the existing .dash-stat-card. No second tile style is introduced —
// the modifier and icon travel with each label from Ehc::MonitoringHelper.
//
// Card anatomy follows the design (.pen node J8GeK): icon, value with an inline change
// note beside it, label, then a caption carrying a fact specific to that card.
export default function StatRow({ funnel, statsContext, summary, labels }) {
  var context = statsContext || {};
  var scheduled = (funnel && funnel.scheduled) || 0;

  // The "Sudah check-in" card counts everyone who arrived (complete + in process),
  // matching the design's 156/184 — not just the ones still being examined.
  var values = {
    scheduled: scheduled,
    checked_in: (funnel && funnel.arrived) || 0,
    complete: (funnel && funnel.complete) || 0,
    no_show: (funnel && funnel.no_show) || 0
  };

  function changeFor(key) {
    if (key === 'scheduled') {
      var delta = (summary && summary.delta_vs_previous_day) || 0;
      return fill(labels.change_vs_yesterday, {
        sign: delta > 0 ? '↗+' : delta < 0 ? '↘' : '→',
        count: Math.abs(delta)
      });
    }

    return fill(labels.change_of_scheduled, {
      percentage: percentage(values[key], scheduled)
    });
  }

  function captionFor(key, card) {
    if (key === 'scheduled') {
      return fill(card.caption, {
        companies: context.companies || 0,
        hospitals: context.hospitals || 0
      });
    }

    if (key === 'checked_in') {
      return fill(card.caption, { count: context.in_process || 0 });
    }

    if (key === 'complete') {
      return context.peak_hour
        ? fill(card.caption, { hour: context.peak_hour, count: context.peak_count || 0 })
        : card.caption_empty;
    }

    return context.top_no_show_company
      ? fill(card.caption, {
          name: context.top_no_show_company,
          count: context.top_no_show_count || 0
        })
      : card.caption_empty;
  }

  return (
    <div className="row dash-stat-cards">
      {['scheduled', 'checked_in', 'complete', 'no_show'].map(function (key) {
        var card = labels[key] || {};

        return (
          <div className="col-sm-6 col-xl-3" key={key}>
            <div className={'dash-stat-card dash-stat-card--' + card.modifier}>
              <div className="dash-stat-card__icon">
                <i className={'zmdi ' + card.icon} />
              </div>
              <div className="dash-stat-card__info">
                <div className="dash-stat-card__value-row">
                  <h2>{values[key]}</h2>
                  <span className="dash-stat-card__change">{changeFor(key)}</span>
                </div>
                <h6>{card.label}</h6>
                <p className="dash-stat-card__caption">{captionFor(key, card)}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
